import React, { useMemo } from 'react'
import { useRisksContext } from 'src/pages/Risks/context/RisksContext'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const RiskCategoryFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const {
    categoryOptions,
    isCategoryOptionsInitialized,
    isCategoryOptionsLoading,
  } = useRisksContext()

  const filterValues = useMemo(() => {
    return [...categoryOptions]
      .sort(
        (a, b) =>
          (a.sortOrder ?? a.value) - (b.sortOrder ?? b.value) ||
          a.name.localeCompare(b.name),
      )
      .map((category) => ({
        label: category.name,
        value: String(category.value),
      }))
  }, [categoryOptions])

  return (
    <FilterDropdown
      filterParam={FilterParam.RISK_CATEGORY}
      filterName={FilterName.RISK_CATEGORY}
      filterValues={filterValues}
      isLoading={isCategoryOptionsLoading || !isCategoryOptionsInitialized}
      isNested={isNested}
    />
  )
}
